import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { ProductSlider } from '../components/product-slider'
import { ProductInfo } from '../components/product-info'
import { useSettings } from '../hooks/use-settings'
import { DetailTable } from '../components/detail-table'
import dedent from 'dedent'
import { ProductsSection } from '../sections/products-section'
import SvgTeaflexLogo from '../generated/svg/teaflex-logo'
import SvgBodifulLabLogo from '../generated/svg/bodiful-lab-logo'
import { useProductData } from '../hooks/use-product-data'
import SvgBefasLogo from '../generated/svg/befas-logo'
import { BefasProductInfo } from '../components/befas-product-info'
import SvgBfCupGreen from '../generated/svg/bf-cup-green'
import SvgBfCupOrange from '../generated/svg/bf-cup-orange'
import SvgBfCupYellow from '../generated/svg/bf-cup-yellow'
import SvgBfCupBeige from '../generated/svg/bf-cup-beige'
import { AssetImage, Image } from '../components/image'
import SvgPg40 from '../generated/svg/pg4-0'
import SvgPg41 from '../generated/svg/pg4-1'
import SvgPg42 from '../generated/svg/pg4-2'
import SvgPg43 from '../generated/svg/pg4-3'
import { BefasDetailTable } from '../components/befas-detail-table'
import SvgPg53 from '../generated/svg/pg5-3'
import SvgRakutenLogo from '../generated/svg/rakuten-logo'

const Outer = styled.div`
  background-color: var(--background-color, transparent);
`

const Inner = styled.div`
  
`

const Detail = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  @media (max-width: 60rem) {
    grid-template-columns: 40% 60%;
  }
  @media (max-width: 40rem) {
    grid-template-columns: 100%;
  }
`

const LeftContainer = styled.div`
  background-color: var(--background-color, transparent);
`

const ProductSliderContainer = styled.div`
  position: sticky;
  height: 100%;
  max-height: 100vh;
  top: 0;
`

const RightContainer = styled.div`
  margin: 4rem var(--page-margin);
  @media (max-width: 40rem) {
    margin-top: 3rem;
    margin-bottom: 0;
  }
`

const ProductInfoContainer = styled.div`
  
`

const DetailTableContainer = styled.div`
  margin-top: 3.75rem;
`

const ProductsContainer = styled.div`
  margin-top: 7.5rem;
  @media (max-width: 40rem) {
    margin-top: 6rem;
  }
`

const Pre = styled.div`
  line-height: 2;
  letter-spacing: 0.05em;
  @media (max-width: 60rem) {
  }
  img {
    width: 100%;
    height: auto;
    display: block;
    margin-top: 1rem;
    margin-bottom: 4.5rem;
    @media (max-width: 60rem) {
  }
  }
  h2 {
    font-size: 2rem;
    line-height: 1.3888888888888888;
    margin-bottom: 1.6875rem;
    @media (max-width: 70rem) {
      font-size: 1.5rem;
      margin-bottom: 1.25rem;
    }
    @media (max-width: 60rem) {
  }
  }
  hr {
    margin-top: 2rem;
    border: none;
    @media (max-width: 60rem) {
  }
  }
  small {
    display: block;
    font-size: 0.625rem;
    line-height: 1.5;
    letter-spacing: 0.05em;
    margin-top: 1.25rem;
    @media (max-width: 60rem) {
  }
  }
  *:first-child {
    margin-top: 0;
    @media (max-width: 60rem) {
  }
  }
  .horizontal-container {
    display: flex;
    gap: 2rem;
    align-items: center;
    @media (max-width: 60rem) {
  }
  }
  .box {
    border: 1px solid currentColor;
    padding: 0.5rem 0.75rem;
    line-height: 2;
    letter-spacing: 0.05em;
    font-family: var(--sans-serif-font);
    @media (max-width: 60rem) {
  }
  }
  dl {
    border: 1px solid currentColor;
    display: flex;
    width: fit-content;
    margin-top: 1rem;
    font-family: var(--sans-serif-font);
    @media (max-width: 60rem) {
  }
    dt {
      padding: 0.5rem 0.75rem;
      width: fit-content;
      @media (max-width: 60rem) {
  }
    }
    dd {
      padding: 0.5rem 0.75rem;
      border-left: 1px solid currentColor;
      width: fit-content;
      @media (max-width: 60rem) {
  }
    }
  }
`

const BefasPre = styled(Pre)`
  font-size: 0.9375rem;
  line-height: 2;
  font-weight: 700;
  font-family: var(--sans-serif-font);
  img, svg {
    display: block;
    width: 100%;
    height: auto;
    margin-bottom: 2.5rem;
  }
  h2 {
    font-size: 1.40625rem;
    line-height: 1.5;
    letter-spacing: 0.05em;
    font-weight: 600;
  }
  small {
    font-size: 0.8em;
    font-weight: 500;
  }
`

const LogoWrapper = styled.div`
  color: var(--beige);
`

type ProductPageProps = {

}
export const ProductGreenTeaPage: FunctionComponent<ProductPageProps> = () => {
  const {themeFileRootPath} = useSettings()
  return <Outer>
    <Inner>
      <Detail>
        <LeftContainer>
          <ProductSliderContainer>
            <ProductSlider slides={[
              {
                img: 'p1-1.png',
                mobileImg: ''
              },
            ]} />
          </ProductSliderContainer>
        </LeftContainer>
        <RightContainer>
          <ProductInfoContainer>
            <ProductInfo data={{
              label: '機能性表示食品',
              logo: <LogoWrapper><SvgTeaflexLogo /></LogoWrapper>,
              nameEn: 'SLIM CLEANSE GREEN TEA',
              nameJa: 'フレッシュグリーンの香り',
              description: '【ノンスイート】15回分／45g',
              tags: [
                '内臓脂肪※',
                'お通じ'
              ],
              tagsNote: '※BMI２５～３０未満の方の腹部の脂肪を減らすと報告。',
              subscriptionNotice: ``,
              variants: [
                {
                  id: '14',
                  label: `
                    定期便コース（30日毎発送コース）<br>
                    30日分/90g ${Math.round(3420 * 1.08).toLocaleString('en-US')}円（税込）
                  `,
                  price: Math.round(3420 * 1.08),
                  netContent: '30日分/90g',
                  buttonLabel: '購入する',
                  subscriptionNotice: `
                    ◆定期便コース（30日毎発送コース）<br>
                    　-初回 ：ご注文受付から3〜5営業日ほどで発送【スリムクレンズグリーンティー 90g1袋】<br>
                    　-2回目：前回発送後から30日ほどで発送【スリムクレンズグリーンティー 90g1袋】】<br>
                    　-3回目以降：前回発送後から30日ほどで発送【スリムクレンズグリーンティー 90g1袋】<br>
                    ・定期便購入回数のお約束はなく、解約・休止が可能です。<br>
                    ※次回発送予定日の7日前までにお電話（0120-664-147）、問い合わせフォーム（https://stoked-store.jp/shop/contact）にてご連絡ください。<br>
                    ・本コースは、お客様から解約、休止のご連絡をいただくまで 自動的に発送する定期便のコースです。<br>
                    ・各回の引き渡し周期変更・一時休止も可能です。<br>
                    ・<strong>返品をご希望の場合<a href=https://stoked-store.jp/shop/law_info>「特定商取引法に基づく表示」</a>内の「返品の取扱条件／返品期限、返品時の送料負担 または解約や退会条件」をご参照ください。</strong><br>
                    ・<strong>初回価格は3,694円(税込)で発送します。(決済手数料、送料無料)</strong><br>
                    ・<strong>2回目以降の価格は3,694円（税込）で発送します。(決済手数料、送料無料)</strong><br>
                    ・<strong>本コースの定期便初回を含む6カ月の販売価格の総額(目安)は22,164円(税込)です。</strong><br>
                    ・ご請求は毎回の商品発送時に発生します。<br>
                    ※クレジットカードのお支払いに関しましては、各ご利用のクレジットカード会社様へお問い合わせください。<br>
                    ・お一人様(1世帯)につき1回限りのご購入とさせていただきます。<br>
                  `
                },
                {
                  id: '	15',
                  label: `
                    30日分/90g ${Math.round(3800 * 1.08).toLocaleString('en-US')}円（税込）
                  `,
                  price: Math.round(3800 * 1.08),
                  netContent: '30日分/90g',
                  buttonLabel: '購入する'
                },
                {
                  id: '	13',
                  label: `
                    15日分/45g ${Math.round(2200 * 1.08).toLocaleString('en-US')}円（税込）
                  `,
                  price: Math.round(2200 * 1.08),
                  netContent: '15日分/45g',
                  buttonLabel: '購入する',
                  // buttonLabel: 'SOLD OUT',
                  // disabled: true,
                }
              ],
              note: `
                ※食生活は、主食、主菜、副菜を基本に、食事のバランスを。<br>
                ※本品は、特定保健用食品と異なり、消費者庁長官による個別審査を受けたものではありません。<br>
                ※本品は、疾病の診断、治療、予防を目的としたものではありません。
              `,
            }} />
          </ProductInfoContainer>
          <DetailTableContainer>

          <DetailTable items={[
              {
                label: '商品特徴',
                value: `
                  <h2>
                    日本初・日本唯一<sup>※1</sup>「内臓脂肪減少<sup>※2</sup>・便通改善」<sup>※3</sup> を実現するグリーンティー
                  </h2>
                  <small>
                    日本初・日本唯一、機能性関与成分のHMPA・植物性乳酸菌K-1を配合したグリーンティー（機能性表示食品）TPCマーケティングリサーチ株式会社調べ（2024年12月時点）<br>
                    ※2対象：BMI２５～３０未満　※3 機能性関与成分GABAによるもの
                  </small><br>
                  お腹周りが気になる方、またお腹の調子、お通じが気になる方に役立つ、HMPAと植物性乳酸菌K-1を配合した機能性表示食品。味と香りを楽しみながら飲める、ノンスイートのグリーンティーです。
                  <img src="${themeFileRootPath}/assets/bundle/images/p1-2.webp">
                  <hr>
                  <h2>
                    機能性関与成分W配合
                  </h2>
                  1食（3g）あたり、BMIが高めな方の腹部の内臓脂肪減少に役立つ3-(4-ヒドロキシ-3-メトキシフェニル)プロピオン酸 (HMPA)を23mg 、お通じの改善に役立つ植物性乳酸菌K-1(L.casei 327)を500億個配合。水溶性・不溶性食物繊維をバランスよく配合し、健やかな日々をサポートします。
                  <img src="${themeFileRootPath}/assets/bundle/images/p1g-1.webp">
                  <hr>
                  <h2>
                    爽やかな、フレッシュグリーンの香り
                  </h2>
                  緑茶の一種である抹茶を使った、ノンスイートタイプのグリーンティー。若い芽を摘み取って作る抹茶は、緑茶の中でもカフェインが多く含まれています。ふんわり広がるフレッシュグリーンの香りはスッキリとしたいとき、シャキッとしたいときの1杯におすすめです。
                  <img src="${themeFileRootPath}/assets/bundle/images/p1-3.webp">
                  <hr>
                  <h2>
                    厳選サポート成分もプラス
                  </h2>
                  毎日、飲み続けるお茶だからこそ、嬉しいサポート成分も厳選して配合しています。ビタミンC、ビタミンB1、ビタミンB2、ビタミンB6、ナイアシンの5種類のビタミンにくわえ、葉酸もプラス。毎日の食生活で不足しがちな成分を、お茶が支えます。
                  <img src="${themeFileRootPath}/assets/bundle/images/p1g-2.webp">
                  <hr>
                  <h2>
                    機能性関与成分：HMPA
                  </h2>
                  米ぬかの発酵物に含まれるポリフェノールの代謝物、3-(4-ヒドロキシ-3-メトキシフェニル)プロピオン酸 (HMPA)は体内のエネルギー代謝に関連するAMPK（体内酵素）を活性化させ糖質や脂質のエネルギー消費を促進する作用により、腹部の脂肪を減らすことに役立つと考えられています。
                  <small>※動物試験等により推察されるメカニズム</small><br>
                  <img src="${themeFileRootPath}/assets/bundle/images/p1g-3.webp">
                  HMPAには、BMIが高めの方の腹部の脂肪(内臓脂肪)とウエスト周囲径を減らす機能が報告されています。
                  <img src="${themeFileRootPath}/assets/bundle/images/p1g-6.webp">
                  <h2>
                    機能性関与成分：植物性乳酸菌K-1
                  </h2>
                  お米から分離された植物性乳酸菌K-1（L.casei 327）は、腸内細胞に働きかけセロトニンの分泌を促し、腸のぜん動運動を活発にさせることで、便通の改善に役立つと考えられています。
                  <small>※動物試験等により推察されるメカニズム</small><br>
                  <img src="${themeFileRootPath}/assets/bundle/images/p1g-7.webp">
                `
              },
              {
                label: '飲み方',
                value: `
                  <img src="${themeFileRootPath}/assets/bundle/images/p1-4.webp">
                  ①コップにティースプーンですりきり1杯（約3g）入れる<br />
                  ②水またはお湯150mLを入れて溶かす<br />
                  ③よくかき混ぜてできあがり
                `
              },
              {
                label: '機能性表示食品に関する表示',
                value: `
                  【届出番号】J652<br>
                  【届出表示】<br>
                  本品には3-(4-ヒドロキシ-3-メトキシフェニル)プロピオン酸(HMPA)、植物性乳酸菌K-1（L.casei 327）が含まれます。<br>
                  HMPAには、BMIが高めの方の腹部の脂肪(内臓脂肪)とウエスト周囲径を減らす機能が報告されています。<br>
                  植物性乳酸菌 K-1（L. casei 327）には、お腹の調子を整えお通じを改善する機能があることが報告されています。<br>
                  ●本品は、事業者の責任において特定の保健の目的が期待できる旨を表示するものとして、消費者庁長官に届出されたものです。ただし、特定保健用食品と異なり、消費者庁長官による個別審査を受けたものではありません。<br>
                  ●本品は、疾病の診断、治療、予防を目的としたものではありません。
                `
              },
              {
                label: '原材料名',
                value: `
                  <p>イソマルトデキストリン（国内製造）、抹茶、米ぬか発酵物、植物性乳酸菌粉末（殺菌）、アルロース、りんご繊維／アラニン、プルラン、ナイアシン、V.C、V.B₂、V.B₆、V.B₁、香料、葉酸</p>
                  <dl>
                    <dt>アレルゲン（特定原材料等28品目中）</dt>
                    <dd>りんご</dd>
                  </dl>
                `
              },
              {
                label: '栄養成分表示1食（3g）あたり',
                value: `
                  <div class="horizontal-container">
                    <div>
                      エネルギー 11.3 kcal<br>
                      たんぱく質 0.35 g<br>
                      脂質 0.05 g<br>
                      炭水化物 2.36 g<br>
                      食塩相当量 0.008 g<br>
                      ビタミンB1　1.3mg<br>
                      ビタミンB2　1.5mg<br>
                      ビタミンB6　1.4mg<br>
                      ナイアシン　15mg<br>
                      ビタミンC　10mg
                    </div>
                    <div class="box">
                      機能性関与成分<br>
                      3-(4-ヒドロキシ-3-メトキシフェニル)プロピオン酸 (HMPA)：23mg<br>
                      植物性乳酸菌K-1(L. casei 327) ：500億個
                    </div>
                  </div>
                `
              },
              {
                label: '摂取上のご注意',
                value: `
                  【摂取上の注意】<br>
                  ●原材料名をご確認のうえ、食物アレルギーのある方はお召し上がりにならないでください。<br>
                  ●濡れた手やスプーンが内容物に触れると、粉末が固まったり、変色する恐れがありますので水分が触れないようにご注意ください。<br>
                  ●開封後はチャックをしっかり閉めて、お早めにお召し上がりください。<br>
                  ●一度に多量摂取すると、お腹が緩くなる場合があります。<br>
                  ●乳幼児の手の届かないところにおいてください。
                `
              }
            ].map(({label, value}) => ({label, value: <Pre dangerouslySetInnerHTML={{__html: dedent(value)}} />}))}/>
          </DetailTableContainer>
        </RightContainer>
      </Detail>
      <ProductsContainer>
        <ProductsSection />
      </ProductsContainer>
    </Inner>
  </Outer>
}
export const ProductRooibosTeaPage: FunctionComponent<ProductPageProps> = () => {
  const {themeFileRootPath} = useSettings()
  return <Outer>
    <Inner>
      <Detail>
        <LeftContainer>
          <ProductSliderContainer>
            <ProductSlider slides={[
              {
                img: 'p2-1.webp',
                mobileImg: ''
              },
            ]} />
          </ProductSliderContainer>
        </LeftContainer>
        <RightContainer>
          <ProductInfoContainer>
            <ProductInfo data={{
              label: '機能性表示食品',
              logo: <LogoWrapper><SvgTeaflexLogo /></LogoWrapper>,
              nameEn: 'SLEEP NIGHT PEACH ROOIBOS TEA ',
              nameJa: 'メロウピーチの香り',
              description: '無果汁【ノンカフェイン】',
              tags: [
                '睡眠<sup>※</sup>',
                '肌の弾力維持'
              ],
              tagsNote: '※睡眠の質（眠りの深さ）の向上に役立つ。',
              subscriptionNotice: ``,
              variants: [
                {
                  id: '22',
                  label: `
                    定期便コース（30日毎発送コース）<br>
                    30日分/90g ${Math.round(3420 * 1.08).toLocaleString('en-US')}円（税込）
                  `,
                  price: Math.round(3420 * 1.08),
                  netContent: '30日分/90g',
                  buttonLabel: '購入する',
                  subscriptionNotice: `
                    ◆定期便コース（30日毎発送コース）<br>
                    　-初回 ：ご注文受付から3〜5営業日ほどで発送【スリープナイトピーチルイボスティー 90g1袋】<br>
                    　-2回目：前回発送後から30日ほどで発送【スリープナイトピーチルイボスティー 90g1袋】】<br>
                    　-3回目以降：前回発送後から30日ほどで発送【スリープナイトピーチルイボスティー 90g1袋】<br>
                    ・定期便購入回数のお約束はなく、解約・休止が可能です。<br>
                    ※次回発送予定日の7日前までにお電話（0120-664-147）、問い合わせフォーム（https://stoked-store.jp/shop/contact）にてご連絡ください。<br>
                    ・本コースは、お客様から解約、休止のご連絡をいただくまで 自動的に発送する定期便のコースです。<br>
                    ・各回の引き渡し周期変更・一時休止も可能です。<br>
                    ・<strong>返品をご希望の場合<a href=https://stoked-store.jp/shop/law_info>「特定商取引法に基づく表示」</a>内の「返品の取扱条件／返品期限、返品時の送料負担 または解約や退会条件」をご参照ください。</strong><br>
                    ・<strong>初回価格は3,694円(税込)で発送します。(決済手数料、送料無料)</strong><br>
                    ・<strong>2回目以降の価格は3,694円（税込）で発送します。(決済手数料、送料無料)</strong><br>
                    ・<strong>本コースの定期便初回を含む6カ月の販売価格の総額(目安)は22,164円(税込)です。</strong><br>
                    ・ご請求は毎回の商品発送時に発生します。<br>
                    ※クレジットカードのお支払いに関しましては、各ご利用のクレジットカード会社様へお問い合わせください。<br>
                    ・お一人様(1世帯)につき1回限りのご購入とさせていただきます。
                  `
                },
                {
                  id: '	17',
                  label: `
                    30日分/90g ${Math.round(3800 * 1.08).toLocaleString('en-US')}円（税込）
                  `,
                  price: Math.round(3800 * 1.08),
                  netContent: '30日分/90g',
                  buttonLabel: '購入する'
                },
                {
                  id: '	16',
                  label: `
                    15日分/45g ${Math.round(2200 * 1.08).toLocaleString('en-US')}円（税込）
                  `,
                  price: Math.round(2200 * 1.08),
                  netContent: '15日分/45g',
                  buttonLabel: '購入する'
                }
              ],
              note: `
                ※食生活は、主食、主菜、副菜を基本に、食事のバランスを。<br>
                ※本品は、特定保健用食品と異なり、消費者庁長官による個別審査を受けたものではありません。<br>
                ※本品は、疾病の診断、治療、予防を目的としたものではありません。
              `,
            }} />
          </ProductInfoContainer>
          <DetailTableContainer>
            <DetailTable items={[
              {
                label: '商品特徴',
                value: `
                  <h2>
                    日本初・日本唯一<sup>※1</sup>「睡眠の質向上・肌の弾力維持」<sup>※2</sup>に役立つルイボスティー
                  </h2>
                  <small>
                    日本初・日本唯一、機能性関与成分のGABAとテアニンを配合することで、睡眠の質の向上を謳った粉末ルイボスティー（機能性表示食品）TPCマーケティングリサーチ株式会社調べ（2024年12月時点）<br>
                    ※2 機能性関与成分GABAによるもの
                  </small><br>
                  眠りが浅いと感じる方や、肌の乾燥に悩みを抱え、弾力を維持したい方に役立つ、GABA配合の機能性表示食品。味と香りを楽しみながら飲める、ノンカフェインのルイボスティーです。
                  <img src="${themeFileRootPath}/assets/bundle/images/p2-2.webp">
                  <hr>
                  <h2>
                    機能性関与成分GABA配合
                  </h2>
                  睡眠の質（眠りの深さ）の向上に役立つ機能、肌の乾燥が気になる方の肌の弾力を維持し、肌の健康を守るのを助ける機能が報告されてる、機能性関与成分のGABAを1食（3g）あたり100mg配合しています。
                  <img src="${themeFileRootPath}/assets/bundle/images/p2g-1.webp">
                  <hr>
                  <h2>
                    気分安らぐ、メロウピーチの香り
                  </h2>
                  マメ科の植物から作られるルイボスティーは、ミネラルや鉄分、ポリフェノールが豊富なお茶。ノンカフェインタイプなので、安らぐひとときにぴったりです。また、ふんわり広がるメロウピーチの香りは、お休み前の1杯におすすめです。
                  <img src="${themeFileRootPath}/assets/bundle/images/p2-3.webp">
                  <hr>
                  <h2>
                    厳選サポート成分もプラス
                  </h2>
                  毎日、飲み続けるお茶だからこそ、嬉しいサポート成分も厳選して配合しています。ビタミンC、ビタミンB1、ビタミンB2、ビタミンB6、ナイアシンの5種類のビタミンにくわえ、セラミドもプラス。おやすみ前の新習慣に相応しいお茶に仕上げました。
                  <img src="${themeFileRootPath}/assets/bundle/images/p2g-2.webp">
                  <hr>
                  <h2>
                    機能性関与成分：GABA 
                  </h2>
                  大麦発酵液を用いて乳酸菌発酵法で作られた機能性関与成分のGABAには、自律神経に作用して睡眠の質を改善し、線維芽細胞の真皮構成成分の産生を促す作用が考えられ、これに基づき、GABAの継続的な摂取により、深い眠りの時間が増加、肌の乾燥が気になる方ので肌弾力の維持が報告されています。<br>
                  <small><sup>※</sup>細胞試験や動物試験等により考えられるメカニズム</small><br>
                  <img src="${themeFileRootPath}/assets/bundle/images/p2g-3.webp">
                  疲労やストレスを感じている人がGABAを2週間摂取することにより、深い睡眠が長くなり、眠りの質が向上したことが報告されています。
                  <img src="${themeFileRootPath}/assets/bundle/images/p2g-4.webp">
                  <hr>
                  肌の乾燥が気になる人がGABAを８週間摂取することにより、肌弾力の３つの指標全てで維持されたことが報告されました。
                  <img src="${themeFileRootPath}/assets/bundle/images/p2g-5.webp">
                `
              },
              {
                label: '飲み方',
                value: `
                  <img src="${themeFileRootPath}/assets/bundle/images/p2-4.webp">
                  ①コップにティースプーンですりきり1杯（約3g）入れる<br />
                  ②水またはお湯150mLを入れて溶かす<br />
                  ③よくかき混ぜてできあがり
                `
              },
              {
                label: '機能性表示食品に関する表示',
                value: `
                  【届出番号】J457<br>
                  【届出表示】<br>
                  本品にはGABAが含まれています。GABAには睡眠の質（眠りの深さ）の向上に役立つ機能、肌の乾燥が気になる方の肌の弾力を維持し、肌の健康を守るのを助ける機能が報告されています。<br>
                  ●本品は、事業者の責任において特定の保健の目的が期待できる旨を表示するものとして、消費者庁長官に届出されたものです。ただし、特定保健用食品と異なり、消費者庁長官による個別審査を受けたものではありません。<br>
                  ●本品は、疾病の診断、治療、予防を目的としたものではありません。
                `
              },
              {
                label: '原材料名',
                value: `
                  <p>イソマルトデキストリン（国内製造）、ルイボス茶エキス末（ルイボス茶、オリゴ糖）、大麦乳酸発酵液ギャバ、ローズマリーエキス末、りんご繊維／トレハロース、環状オリゴ糖、L-テアニン、ナイアシン、プルラン、V.C、香料、ヒアルロン酸、V.B2、V.B6、V.B1</p>
                  <dl>
                    <dt>アレルゲン（特定原材料等28品目中）</dt>
                    <dd>りんご</dd>
                  </dl>
                `
              },
              {
                label: '栄養成分表示1食（3g）あたり',
                value: `
                  <div class="horizontal-container">
                    <div>
                      エネルギー 11.3 kcal<br>
                      たんぱく質 0.19 g<br>
                      脂質 0.01 g<br>
                      炭水化物 2.62 g<br>
                      食塩相当量 0.004 g<br>
                      ビタミンB1 1.3 mg<br>
                      ビタミンB2 1.5 mg<br>
                      ビタミンB6 1.4 mg<br>
                      ナイアシン 15 mg<br>
                      ビタミンC 10 mg
                    </div>
                    <div class="box">
                      機能性関与成分　GABA：100mg
                    </div>
                  </div>
                `
              },
              {
                label: '摂取上のご注意',
                value: `
                  【摂取上の注意】<br>
                  ●原材料名をご確認のうえ、食物アレルギーのある方はお召し上がりにならないでください。<br>
                  ●濡れた手やスプーンが内容物に触れると、粉末が固まったり、変色する恐れがありますので水分が触れないようにご注意ください。<br>
                  ●開封後はチャックをしっかり閉めて、お早めにお召し上がりください。<br>
                  ●一度に多量摂取すると、お腹が緩くなる場合があります。<br>
                  ●乳幼児の手の届かないところにおいてください。<br>
                  ●降圧薬を使用している方は医師、薬剤師に相談してください。
                `
              }
            ].map(({label, value}) => ({label, value: <Pre dangerouslySetInnerHTML={{__html: dedent(value)}} />}))}/>
          </DetailTableContainer>
        </RightContainer>
      </Detail>
      <ProductsContainer>
        <ProductsSection />
      </ProductsContainer>
    </Inner>
  </Outer>
}
export const ProductBodifulLabPage: FunctionComponent<ProductPageProps> = () => {
  return <Outer>
    <Inner>
      <Detail>
        <LeftContainer>
          <ProductSliderContainer>
            <ProductSlider slides={[
              {
                img: 'p3-1.webp',
                mobileImg: ''
              },
            ]} />
          </ProductSliderContainer>
        </LeftContainer>
        <RightContainer>
          <ProductInfoContainer>
            <ProductInfo data={{
              logo: <SvgBodifulLabLogo />,
              nameEn: '骨盤スマートベルト',
              description: '着用することで、腰まわりをやさしく支えながら、自然な姿勢を後押しする骨盤スマートベルトです。軽やかな毎日を送るために、早速、ご活用ください。',
              tags: [
              ],
              tagsNote: '',
              subscriptionNotice: ``,
              variants: [
                {
                  id: '252',
                  label: `
                    S / 68-78cm<br>
                    ${Math.round(8000 * 1.1).toLocaleString('en-US')}円（税込）
                  `,
                  price: Math.round(8000 * 1.1),
                  netContent: 'S/68-78cm',
                  buttonLabel: 'Sサイズを購入する',
                },
                {
                  id: '61',
                  label: `
                    M / 78-88cm<br>
                    ${Math.round(8000 * 1.1).toLocaleString('en-US')}円（税込）
                  `,
                  price: Math.round(8000 * 1.1),
                  netContent: 'M/78-88cm',
                  buttonLabel: 'Mサイズを購入する',
                },
                {
                  id: '62',
                  label: `
                    L / 88-98cm<br>
                    ${Math.round(8000 * 1.1).toLocaleString('en-US')}円（税込）
                  `,
                  price: Math.round(8000 * 1.1),
                  netContent: 'L/88-98cm',
                  buttonLabel: 'Lサイズを購入する',
                },
                {
                  id: '253',
                  label: `
                    XL / 98-108cm<br>
                    ${Math.round(8000 * 1.1).toLocaleString('en-US')}円（税込）
                  `,
                  price: Math.round(8000 * 1.1),
                  netContent: 'XL/98-108cm',
                  buttonLabel: 'XLサイズを購入する',
                }
              ],
              note: `
              `,
            }} />
          </ProductInfoContainer>
          <DetailTableContainer>
            <DetailTable items={[
            ].map(({label, value}) => ({label, value: <Pre dangerouslySetInnerHTML={{__html: dedent(value)}} />}))}/>
          </DetailTableContainer>
        </RightContainer>
      </Detail>
      <ProductsContainer>
        <ProductsSection />
      </ProductsContainer>
    </Inner>
  </Outer>
}

export const ProductShapeHipPage: FunctionComponent<ProductPageProps> = () => {
  return <Outer>
    <Inner>
      <Detail>
        <LeftContainer>
          <ProductSliderContainer>
            <ProductSlider slides={[
              {
                img: 'p6-1.webp',
                mobileImg: ''
              },
            ]} />
          </ProductSliderContainer>
        </LeftContainer>
        <RightContainer>
          <ProductInfoContainer>
            <ProductInfo data={{
              logo: <SvgBodifulLabLogo />,
              nameEn: 'シェイプヒップ',
              description: '着用時の心地よさとスタイルケアを両立した「BodiFul Lab. シェイプヒップ」。温感素材と立体設計がヒップラインをすっきり見せ、薄手で快適なフィット感を実現します。',
              tags: [
              ],
              tagsNote: '',
              subscriptionNotice: ``,
              variants: [
              ],
              channels: [
                {
                  label: '楽天で購入',
                  url: 'https://item.rakuten.co.jp/endeavour/bol005-40825013/'
                }
              ],
              note: `
              `,
            }} />
          </ProductInfoContainer>
          <DetailTableContainer>
            <DetailTable items={[
            ].map(({label, value}) => ({label, value: <Pre dangerouslySetInnerHTML={{__html: dedent(value)}} />}))}/>
          </DetailTableContainer>
        </RightContainer>
      </Detail>
      <ProductsContainer>
        <ProductsSection />
      </ProductsContainer>
    </Inner>
  </Outer>
}


export const ProductBodifulLabSinglePage: FunctionComponent<ProductPageProps> = () => {
  const sku = location.pathname.match(/(?<=\/)[^\/]+?$/)?.[0]
  const singleData = useProductData(sku)
  return <Outer>
    <Inner>
      <Detail>
        <LeftContainer>
          <ProductSliderContainer>
            <ProductSlider slides={[
              {
                img: 'p3-1.webp',
                mobileImg: ''
              },
            ]} />
          </ProductSliderContainer>
        </LeftContainer>
        <RightContainer>
          <ProductInfoContainer>
            <ProductInfo data={{
              logo: <SvgBodifulLabLogo />,
              nameEn: '骨盤スマートベルト',
              description: '着用することで、腰まわりをやさしく支えながら、自然な姿勢を後押しする骨盤スマートベルトです。軽やかな毎日を送るために、早速、ご活用ください。',
              tags: [
              ],
              tagsNote: '',
              subscriptionNotice: ``,
              variants: [
                {
                  id: '60',
                  label: `
                    S / 68-78cm<br>
                    ${Math.round(8000 * 1.1).toLocaleString('en-US')}円（税込）
                  `,
                  price: Math.round(8000 * 1.1),
                  netContent: 'S/68-78cm',
                  buttonLabel: 'Sサイズを購入する',
                },
                {
                  id: '61',
                  label: `
                    M / 78-88cm<br>
                    ${Math.round(8000 * 1.1).toLocaleString('en-US')}円（税込）
                  `,
                  price: Math.round(8000 * 1.1),
                  netContent: 'M/78-88cm',
                  buttonLabel: 'Mサイズを購入する',
                },
                {
                  id: '62',
                  label: `
                    L / 88-98cm<br>
                    ${Math.round(8000 * 1.1).toLocaleString('en-US')}円（税込）
                  `,
                  price: Math.round(8000 * 1.1),
                  netContent: 'L/88-98cm',
                  buttonLabel: 'Lサイズを購入する',
                },
                {
                  id: '63',
                  label: `
                    XL / 98-108cm<br>
                    ${Math.round(8000 * 1.1).toLocaleString('en-US')}円（税込）
                  `,
                  price: Math.round(8000 * 1.1),
                  netContent: 'XL/98-108cm',
                  buttonLabel: 'XLサイズを購入する',
                }
              ],
              note: `
              `,
            }} />
          </ProductInfoContainer>
          <DetailTableContainer>
            <DetailTable items={[
            ].map(({label, value}) => ({label, value: <Pre dangerouslySetInnerHTML={{__html: dedent(value)}} />}))}/>
          </DetailTableContainer>
        </RightContainer>
      </Detail>
      <ProductsContainer>
        <ProductsSection />
      </ProductsContainer>
    </Inner>
  </Outer>
}
/*
下の内容のAmazon/楽天/Qoo10のURLが確定しておりましたら、ご共有いただけると助かります。
■7日間
単品：BF0085_BFHS7_F_na
定期：BF0086_BFHS7_122_153030_F_na
Amazon/楽天/Qoo10

■3日間
Amazon/楽天/Qoo10のみ

Amazon：未開設
楽天：https://item.rakuten.co.jp/endeavour/bfs001-41425006/
Qoo10：未開設
一旦、上記でご設定お願いしてもよろしいでしょうか(bow)
*/

const BefasRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.25fr;
  gap: 3rem;
  @media (max-width: 40rem) {
  }
  & + & {
    margin-top: 4rem;
  }
`

const BefasRowImage = styled.div`
  margin: 0 !important;
  @media (max-width: 40rem) {
  }
`

const BefasRowText = styled.div`
  font-size: 0.8rem;
  line-height: 1.7333333333333334;
  letter-spacing: -0.04em;
  font-weight: 500;
  h3 {
    font-size: 1.40625rem;
    line-height: 1.5;
    letter-spacing: 0.05em;
    margin-bottom: 0.5rem;
  }
  strong {
    font-size: 0.75rem;
    line-height: 1.5;
    letter-spacing: 0.05em;
    font-weight: 500;
    display: block;
  }
  b {
    line-height: 1.5;
    letter-spacing: 0.05em;
    font-weight: 700;
    margin-block: 1rem;
    display: block;
  }
  @media (max-width: 40rem) {
  }
`

const BefasRow2 = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  margin-top: 2rem;
  gap: 3rem;
  @media (max-width: 40rem) {
  }
`

const BefasRow2Image = styled.div`
  @media (max-width: 40rem) {
  }
  img {
    display: block;
    width: 100%;
    height: auto;
  }
`

const BefasRow2Text = styled.div`
  @media (max-width: 40rem) {
  }
`

const BuyLinkContainer = styled.div`
  margin-bottom: 6rem;
  font-family: var(--sans-serif-font);
`

const BuyLinkLabel = styled.div`
  font-size: 1rem;
  font-weight: 700;
`

const BuyLinkList = styled.div`
  display: flex;
  margin-top: 1rem;
`

const BuyLinkItem = styled.a`
  background-color: #FFF7EF;
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: opacity 0.4s;
  &:hover {
    opacity: 0.5;
  }
`

const BuyLinkItemLogo = styled.div`
  svg {
    height: 2rem;
  }
`
const BuyLinkItemLabel = styled.div`
  font-size: 0.75rem;
  font-weight: 700;
`

export const ProductBefas7daysPage: FunctionComponent<ProductPageProps> = () => {
  const {themeFileRootPath} = useSettings()
  return <Outer style={{'--background-color': '#F9F0E3', '--button-color': '#EA5514'}}>
    <Inner>
      <Detail>
        <LeftContainer style={{'--background-color': '#A6A199'}}>
          <ProductSliderContainer>
            <ProductSlider slides={[
              {
                img: 'p4-1.webp',
                fillMode: 'contain',
                backgroundColor: '#F9F0E3'
              },
              {
                img: 'p4-2.webp',
              },
              {
                img: 'p4-3.webp',
              },
              {
                img: 'p4-4.webp',
              },
              {
                img: 'p4-5.webp',
              },
            ]} />
          </ProductSliderContainer>
        </LeftContainer>
        <RightContainer>
          <ProductInfoContainer>
            <BefasProductInfo data={{
              logo: <SvgBefasLogo />,
              nameEn: '本格ファスティングプログラム（7日間）',
              description: '「がんばりすぎない、でも自分を大切にしたい。」そんな気持ちに寄り添う新しいファスティング7日間のファスティングプログラムです。',
              tags: [
              ],
              tagsNote: '',
              variants: [
                {
                  id: '172',
                  label: `
                    定期便<br>
                    <table>
                      <tr>
                        <td><small>初回</small></td>
                        <td><small>1箱</small></td>
                        <td>${Math.round(2111 * 1.08).toLocaleString('en-US')}円<small>（税込）</small></td>
                      </tr>
                      <tr>
                        <td><small>２回目以降</small></td>
                        <td><small>30日毎に2箱</small></td>
                        <td>${Math.round(8761 * 1.08).toLocaleString('en-US')}円<small>（税込）</small></td>
                      </tr>
                    </table>
                  `,
                  netContent: '7日間',
                  priceLabel: '初回',
                  price: Math.round(2111 * 1.08),
                  buttonLabel: '購入する',
                  subscriptionNotice: `
                    ◆定期便コース（30日毎発送コース※初回、2回目を除く）<br>
                    　-初回 ：ご注文受付から3〜5営業日ほどで発送【Befas本格セット1箱】<br>
                    　-2回目：前回発送後から15日ほどで発送【Befas本格セット2箱】<br>
                    　-3回目以降：前回発送後から30日ほどで発送【Befas本格セット2箱】<br>
                    ・定期便購入回数のお約束はなく、解約・休止が可能です。<br>
                    ※次回発送予定日の7日前までにお電話（0120-664-147）、<a href="/shop/contact">問い合わせフォーム</a>にてご連絡ください。<br>
                    ・本コースは、お客様から解約、休止のご連絡をいただくまで 自動的に発送する定期便のコースです。<br>
                    ・各回の引き渡し周期変更・一時休止も可能です。<br>
                    ・返品をご希望の場合「<a href="/shop/law_info">特定商取引法に基づく表示</a>」内の「返品の取扱条件／返品期限、返品時の送料負担 または解約や退会条件」をご参照ください。<br>
                    ・初回価格は2,280円(税込)で発送します。(決済手数料、送料無料)<br>
                    ・2回目以降の価格は9,462円（税込）で発送します。(決済手数料、送料無料)<br>
                    ・本コースの定期便初回を含む6カ月の販売価格の総額(目安)は59,052円(税込)です。<br>
                    ・ご請求は毎回の商品発送時に発生します。<br>
                    ※クレジットカードのお支払いに関しましては、各ご利用のクレジットカード会社様へお問い合わせください。<br>
                    ・お一人様(1世帯)につき1回限りのご購入とさせていただきます。
                  `,
                },
                {
                  id: '173',
                  label: `
                    単品<br>
                    ${Math.round(4611 * 1.08).toLocaleString('en-US')}円<small>（税込）</small>
                  `,
                  price: Math.round(4611 * 1.08),
                  netContent: '7日間',
                  buttonLabel: '購入する',
                }
              ],
              note: `
              `,
            }}
            setItems={[
              {
                icon: <SvgBfCupGreen />,
                name: '酵素グリーンスムージー（バナナ味）',
                qty: 6
              },
              {
                icon: <SvgBfCupOrange />,
                name: '酵素トロピカルスムージー（マンゴー味）',
                qty: 5
              },
              {
                icon: <SvgBfCupYellow />,
                name: 'たっぷり生姜の鶏だし粥',
                qty: 2
              },
              {
                icon: <SvgBfCupBeige />,
                name: 'フライドオニオンとほうれん草のクリームスープ',
                qty: 1
              }
            ]}
          />
          </ProductInfoContainer>
          <DetailTableContainer>
            <BefasDetailTable items={[
              {
                label: `
                  ファスティングとは
                `,
                value: `
                  ファスティングとは、「食べないこと」ではなく、「食を整えること」。一定の期間、消化に負担の少ない食事や専用スムージーを取り入れながら、日々の食生活を見直し、からだを内側から整えていく新しい習慣です。Befasオリジナルファスティングプログラムでは、医師×ダイエットエキスパートのW監修でリアルな知見を凝縮しました。<br>
                  <img src="${themeFileRootPath}/assets/bundle/images/pd4-1.webp">
                `
              },
              {
                label: `
                  医師とダイエットエキスパートの監修
                `,
                value: <>
                  <BefasRow>
                    <BefasRowImage>
                      <AssetImage src="pd4-2.webp" />
                    </BefasRowImage>
                    <BefasRowText>
                      <h3>五藤 良将 医師</h3>
                      自己流や極端な断食は、栄養不足やリバウンドのリスクを高めることがあります。本プログラムでは「準備期・ファスティング本番・回復期」の3ステップで食事内容と栄養バランスを段階的に調整※し、初めての方でも無理なく取り組める設計にしました。
短期間で変化を感じやすい手軽さと、生活習慣づくりの両立を目指す方におすすめのプログラムです。
                    </BefasRowText>
                  </BefasRow>
                  <BefasRow>
                    <BefasRowImage>
                      <AssetImage src="pd4-3.webp" />
                    </BefasRowImage>
                    <BefasRowText>
                      <strong>ダイエットエキスパート</strong>
                      <h3>和田 清香 先生</h3>
                      自数多くのダイエットを指導してきた経験から痛感しているのは、『頑張る』だけでは長続きしないということです。だからこそ、Befasファスティングプログラムは、食べるタイミングや内容をしっかりガイドしています。『食べられなくてツラい』のではなく、『正しく食べながらスリムになっていく』喜びを、ぜひ多くの女性に体験していただきたいと思っています。
                    </BefasRowText>
                  </BefasRow>
                </>
              },
              {
                label: `
                  Befasプログラムを実施
                `,
                value: <>
                  <SvgPg40 /><br />
                  Befasは、無理のないプログラム設計で、食習慣と向き合うきっかけをサポートします。モニター調査では、食事の内容やリズムに変化を感じたという声も。“がんばりすぎないから、続けられる”——そんなリアルな実感が、Befasの魅力です。
                </>
              },
              {
                label: `
                  やり遂げた人の割合
                `,
                value: <>
                  <SvgPg41 /><br />
                  <small>
                    ※27名のモニターが本プログラムを1か月実施した際の平均体重変化。愛国学園短期大学 古谷彰子氏による分析<br />
                    ※結果には個人差があり、全ての方に同様の効果を保証するものではありません。
                  </small>
                </>
              },
              {
                label: `
                  料理研究家が開発をサポート
                `,
                value: <>
                  <BefasRow>
                    <BefasRowImage>
                      <AssetImage src="pd4-4.webp" />
                    </BefasRowImage>
                    <BefasRowText>
                      <b>”栄養バランス”と”美味しさ”を追求</b>
                      <strong>料理研究家</strong>
                      <h3>ほりえちさこさん</h3>
                      料理研究家・ほりえちさこさんが開発に加わり、2種類の専用スムージーをはじめとする各種サポート食の"美味しさ"を追求。
                      <a href="https://befas.com/about#recipe">ほりえちさこさん考案のアレンジレシピはこちら</a>
                    </BefasRowText>
                  </BefasRow>
                  </>
              },
              {
                label: `
                  ステップ
                `,
                value: <>
                  <h2>Befasの3STEP ファスティング</h2>
                  臨床試験で効果が証明されているファスティング方法で「準備✕ファスティング✕回復」の3ステップによって空腹のつらさを軽減しながら、体質改善やダイエット効果を最大限に引き出せるオリジナルブログラムです。
                  <br />
                  <br />
                  <br />
                  <SvgPg42 />
                  <br />
                  <br />
                  Befasは、「準備期」「ファスティング期」「回復期」の3ステップで構成された、やさしい設計のファスティングプログラム。無理のないステップで進めることで、空腹のストレスを感じにくく、自分のリズムに合わせて取り入れられます。日々の食生活を見直したい方、食習慣をリセットしたい方におすすめのアプローチです。
                  <br />
                  <br />
                  <BefasRow2>
                    <BefasRow2Image>
                      <AssetImage src="pd4-5.webp" />
                    </BefasRow2Image>
                    <BefasRow2Text>
                      つくりかたは、食べる前に水やお湯に溶かすだけ。使い切り個包装&常温保存可能だから使いやすい。いつでもどこでも、気軽にファスティングを楽しめる。
                    </BefasRow2Text>
                  </BefasRow2>
                </>
              },
              {
                label: `
                  プログラム
                `,
                value: <>
                ファスティング初心者の方におすすめの7日間プログラム
                <br />
                <br />
                 <SvgPg43 />
                 <small>※食事内容は一例です。セットには含まれません。</small>
                </>
              },
              {
                label: `
                  原材料
                `,
                value: <>
                <small>
                  【酵素グリーンスムージー（バナナ風味）】<br />
                  ●名称：食物繊維含有加工食品<br />
                  ●原材料名：難消化性デキストリン（国内製造）、還元麦芽糖水飴、クマザサ末、大豆タンパク、バナナピューレ、グルコマンナン、デキストリン、サイリウムハスク末、ドロマイト、穀物発酵エキス末（マルトデキストリン、穀物発酵抽出物）、植物発酵エキス末（難消化性デキストリン、植物発酵エキス（黒糖、リンゴ、玄米麹、その他））、L-カルニチンフマル酸塩、酵母（ビオチン含有）、酵母（亜鉛・マンガン・銅・ヨウ素・セレン・クロム・モリブデン含有）、ブドウ糖、温州みかん抽出物、植物性乳酸菌（殺菌）／増粘剤（キサンタンガム）、クエン酸、甘味料（アスパルテーム・L-フェニルアラニン化合物、スクラロース）、香料、クチナシ色素、ビタミンC、ナイアシン、パントテン酸カルシウム、シクロデキストリン、ビタミンB?、ビタミンB?、ビタミンB?、葉酸、ビタミンB?? （一部に小麦・大豆・りんご・バナナ・もも・キウイフルーツを含む）<br />
                  <br />
                  【酵素トロピカルスムージー（マンゴー風味）】<br />
                  ●名称：食物繊維含有加工食品<br />
                  ●原材料名：難消化性デキストリン（国内製造）、還元麦芽糖水飴、デキストリン、大豆タンパク、グルコマンナン、サイリウムハスク末、ドロマイト、クマザサ末、穀物発酵エキス末（マルトデキストリン、穀物発酵抽出物）、マンゴーピューレ、植物発酵エキス末（難消化性デキストリン、植物発酵エキス（黒糖、リンゴ、玄米麹、その他））、L-カルニチンフマル酸塩、酵母（ビオチン含有）、酵母（亜鉛・マンガン・銅・ヨウ素・セレン・クロム・モリブデン含有）、ブドウ糖、温州みかん抽出物、植物性乳酸菌（殺菌）／増粘剤（キサンタンガム）、クエン酸、香料、甘味料（アスパルテーム・L-フェニルアラニン化合物、スクラロース）、紅花色素、ビタミンC、ナイアシン、クチナシ色素、パントテン酸カルシウム、シクロデキストリン、ビタミンB?、ビタミンB?、ビタミンB?、葉酸、ビタミンB?? （一部に小麦・大豆・りんご・バナナ・もも・キウイフルーツを含む）<br />
                  <br />
                  【フライドオニオンとほうれん草のクリームスープ】<br />
                  ●名称：乾燥スープ<br />
                  ●原材料名：大豆たんぱく（アメリカ製造）、水溶性食物繊維（イソマルトデキストリン）、乳たんぱく、クリーミングパウダー、具（オニオン、ほうれん草、米油）、乳たんぱく加水分解物、脱脂粉乳、食塩、ブイヨン（食塩、砂糖、酵母エキス、デキストリン、たまねぎ、香辛料）、ドロマイト、乳等を主要原料とする食品、野菜エキスパウダー、でん粉、ポークエキスパウダー、粉末醤油、デキストリン、グルコマンナン、オニオンパウダー、香辛料／クエン酸K、トレハロース、調味料（アミノ酸等）、増粘剤（グァー、CMC）、ソルビトール、植物レシチン、ビタミンC、ピロリン酸鉄、ナイアシン、ビタミンE、パントテン酸Ca、ビタミンB?、ビタミンB?、ビタミンA、ビタミンB?、ビタミンD、葉酸、ビタミンK?、ビタミンB??、カラメル色素 （一部に乳成分・小麦・大豆・豚肉を含む）<br />
                  <br />
                  【たっぷり生姜の鶏だし粥】<br />
                  ●名称：乾燥がゆ<br />
                  ●原材料名：米加工品（米（国産））、乾燥味付鶏肉、チキンエキス、中華調味料、生姜パウダー、食塩、デキストリン、酵母エキス、乾燥ねぎ、砂糖、香辛料／調味料（アミノ酸等）、香料 （一部に小麦・乳成分・ごま・大豆・鶏肉・豚肉・ゼラチンを含む）
                  </small>
                </>
              },
              {
                label: `
                  内容量
                `,
                value: <>
                  <small>
                    ・酵素グリーンスムージー（バナナ風味）6g × 6袋<br />
                    ・酵素トロピカルスムージー（マンゴー風味）6g × 5袋<br />
                    ・フライドオニオンとほうれん草のクリームスープ 25g × 2袋<br />
                    ・たっぷり生姜の鶏だし粥 13.3g × 1袋
                  </small>
                </>
              },
              {
                label: `
                  注意
                `,
                value: <>
                  <small>
                  【摂取上の注意】<br />
                  ●原材料名をご確認のうえ、食物アレルギーのある方はお召し上がりにならないでください。●濡れた手やスプーンが内容物に触れると、粉末が固まったり、変色する恐れがありますので水分が触れないようにご注意ください。●開封後はチャックをしっかり閉めて、お早めにお召し上がりください。一度に多量摂取すると、お腹が緩くなる場合があります。●乳幼児の手の届かないところにおいてください。
                  </small>
                </>
              },
            ].map(({label, value}) => ({label, value: typeof value === 'string' ? <BefasPre dangerouslySetInnerHTML={{__html: dedent(value)}} /> : <BefasPre>{value}</BefasPre>}))}/>
          </DetailTableContainer>
        </RightContainer>
      </Detail>
      <ProductsContainer>
        <ProductsSection />
      </ProductsContainer>
    </Inner>
  </Outer>
}
export const ProductBefas3daysPage: FunctionComponent<ProductPageProps> = () => {
  const {themeFileRootPath} = useSettings()
  return <Outer style={{'--background-color': '#F9F0E3', '--button-color': '#EA5514'}}>
    <Inner>
      <Detail>
        <LeftContainer style={{'--background-color': '#A6A199'}}>
          <ProductSliderContainer>
            <ProductSlider slides={[
              {
                img: 'p5-1.webp',
                fillMode: 'contain',
                backgroundColor: '#F9F0E3'
              },
              {
                img: 'p4-2.webp',
              },
              {
                img: 'p4-3.webp',
              },
              {
                img: 'p4-4.webp',
              },
              {
                img: 'p4-5.webp',
              },
            ]} />
          </ProductSliderContainer>
        </LeftContainer>
        <RightContainer>
          <ProductInfoContainer>
            <BefasProductInfo data={{
              logo: <SvgBefasLogo />,
              nameEn: '週末ファスティングプログラム（3日間）',
              description: 'Befas「週末ファスティング」で、食べ過ぎリセット＆すっきり習慣',
              tags: [
              ],
              tagsNote: '',
              subscriptionNotice: ``,
              variants: [
              ],
              note: `
              `,
            }}
            setItems={[
              {
                icon: <SvgBfCupGreen />,
                name: '酵素グリーンスムージー（バナナ味）',
                qty: 3
              },
              {
                icon: <SvgBfCupOrange />,
                name: '酵素トロピカルスムージー（マンゴー味）',
                qty: 2
              },
              {
                icon: <SvgBfCupYellow />,
                name: 'たっぷり生姜の鶏だし粥',
                qty: 1
              },
              {
                icon: <SvgBfCupBeige />,
                name: 'フライドオニオンとほうれん草のクリームスープ',
                qty: 1
              }
            ]}
          />
          </ProductInfoContainer>
          <BuyLinkContainer>
            <BuyLinkLabel>
              ご購入はこちらから
            </BuyLinkLabel>
            <BuyLinkList>
              <BuyLinkItem href="https://item.rakuten.co.jp/endeavour/bfs001-41425006/" target="_blank">
                <BuyLinkItemLogo>
                  <SvgRakutenLogo />
                </BuyLinkItemLogo>
                <BuyLinkItemLabel>
                  楽天市場
                </BuyLinkItemLabel>
              </BuyLinkItem>
            </BuyLinkList>
          </BuyLinkContainer>
          <DetailTableContainer>
            <BefasDetailTable items={[
              {
                label: `
                  ファスティングとは
                `,
                value: `
                  ファスティングとは、「食べないこと」ではなく、「食を整えること」。一定の期間、消化に負担の少ない食事や専用スムージーを取り入れながら、日々の食生活を見直し、からだを内側から整えていく新しい習慣です。Befasオリジナルファスティングプログラムでは、医師×ダイエットエキスパートのW監修でリアルな知見を凝縮しました。<br>
                  <img src="${themeFileRootPath}/assets/bundle/images/pd4-1.webp">
                `
              },
              {
                label: `
                  医師とダイエットエキスパートの監修
                `,
                value: <>
                  <BefasRow>
                    <BefasRowImage>
                      <AssetImage src="pd4-2.webp" />
                    </BefasRowImage>
                    <BefasRowText>
                      <h3>五藤 良将 医師</h3>
                      自己流や極端な断食は、栄養不足やリバウンドのリスクを高めることがあります。本プログラムでは「準備期・ファスティング本番・回復期」の3ステップで食事内容と栄養バランスを段階的に調整※し、初めての方でも無理なく取り組める設計にしました。
短期間で変化を感じやすい手軽さと、生活習慣づくりの両立を目指す方におすすめのプログラムです。
                    </BefasRowText>
                  </BefasRow>
                  <BefasRow>
                    <BefasRowImage>
                      <AssetImage src="pd4-3.webp" />
                    </BefasRowImage>
                    <BefasRowText>
                      <strong>ダイエットエキスパート</strong>
                      <h3>和田 清香 先生</h3>
                      自数多くのダイエットを指導してきた経験から痛感しているのは、『頑張る』だけでは長続きしないということです。だからこそ、Befasファスティングプログラムは、食べるタイミングや内容をしっかりガイドしています。『食べられなくてツラい』のではなく、『正しく食べながらスリムになっていく』喜びを、ぜひ多くの女性に体験していただきたいと思っています。
                    </BefasRowText>
                  </BefasRow>
                </>
              },
              {
                label: `
                  Befasプログラムを実施
                `,
                value: <>
                  <SvgPg40 /><br />
                  Befasは、無理のないプログラム設計で、食習慣と向き合うきっかけをサポートします。モニター調査では、食事の内容やリズムに変化を感じたという声も。“がんばりすぎないから、続けられる”——そんなリアルな実感が、Befasの魅力です。
                </>
              },
              {
                label: `
                  やり遂げた人の割合
                `,
                value: <>
                  <SvgPg41 /><br />
                  <small>
                    ※27名のモニターが本プログラムを1か月実施した際の平均体重変化。愛国学園短期大学 古谷彰子氏による分析<br />
                    ※結果には個人差があり、全ての方に同様の効果を保証するものではありません。
                  </small>
                </>
              },
              {
                label: `
                  料理研究家が開発をサポート
                `,
                value: <>
                  <BefasRow>
                    <BefasRowImage>
                      <AssetImage src="pd4-4.webp" />
                    </BefasRowImage>
                    <BefasRowText>
                      <b>”栄養バランス”と”美味しさ”を追求</b>
                      <strong>料理研究家</strong>
                      <h3>ほりえちさこさん</h3>
                      料理研究家・ほりえちさこさんが開発に加わり、2種類の専用スムージーをはじめとする各種サポート食の"美味しさ"を追求。
                      <a href="https://befas.com/about#recipe">ほりえちさこさん考案のアレンジレシピはこちら</a>
                    </BefasRowText>
                  </BefasRow>
                </>
              },
              {
                label: `
                  ステップ
                `,
                value: <>
                  <h2>Befasの3STEP ファスティング</h2>
                  臨床試験で効果が証明されているファスティング方法で「準備✕ファスティング✕回復」の3ステップによって空腹のつらさを軽減しながら、体質改善やダイエット効果を最大限に引き出せるオリジナルブログラムです。
                  <br />
                  <br />
                  <br />
                  <SvgPg42 />
                  <br />
                  <br />
                  Befasは、「準備期」「ファスティング期」「回復期」の3ステップで構成された、やさしい設計のファスティングプログラム。無理のないステップで進めることで、空腹のストレスを感じにくく、自分のリズムに合わせて取り入れられます。日々の食生活を見直したい方、食習慣をリセットしたい方におすすめのアプローチです。
                  <br />
                  <br />
                  <BefasRow2>
                    <BefasRow2Image>
                      <AssetImage src="pd4-5.webp" />
                    </BefasRow2Image>
                    <BefasRow2Text>
                      つくりかたは、食べる前に水やお湯に溶かすだけ。使い切り個包装&常温保存可能だから使いやすい。いつでもどこでも、気軽にファスティングを楽しめる。
                    </BefasRow2Text>
                  </BefasRow2>
                </>
              },
              {
                label: `
                  プログラム
                `,
                value: <>
                ファスティング初心者の方におすすめの7日間プログラム
                <br />
                <br />
                 <SvgPg53 />
                 <small>※食事内容は一例です。セットには含まれません。</small>
                </>
              },
              {
                label: `
                  原材料
                `,
                value: <>
                <small>
                  【酵素グリーンスムージー（バナナ風味）】<br />
                  ●名称：食物繊維含有加工食品<br />
                  ●原材料名：難消化性デキストリン（国内製造）、還元麦芽糖水飴、クマザサ末、大豆タンパク、バナナピューレ、グルコマンナン、デキストリン、サイリウムハスク末、ドロマイト、穀物発酵エキス末（マルトデキストリン、穀物発酵抽出物）、植物発酵エキス末（難消化性デキストリン、植物発酵エキス（黒糖、リンゴ、玄米麹、その他））、L-カルニチンフマル酸塩、酵母（ビオチン含有）、酵母（亜鉛・マンガン・銅・ヨウ素・セレン・クロム・モリブデン含有）、ブドウ糖、温州みかん抽出物、植物性乳酸菌（殺菌）／増粘剤（キサンタンガム）、クエン酸、甘味料（アスパルテーム・L-フェニルアラニン化合物、スクラロース）、香料、クチナシ色素、ビタミンC、ナイアシン、パントテン酸カルシウム、シクロデキストリン、ビタミンB?、ビタミンB?、ビタミンB?、葉酸、ビタミンB?? （一部に小麦・大豆・りんご・バナナ・もも・キウイフルーツを含む）<br />
                  <br />
                  【酵素トロピカルスムージー（マンゴー風味）】<br />
                  ●名称：食物繊維含有加工食品<br />
                  ●原材料名：難消化性デキストリン（国内製造）、還元麦芽糖水飴、デキストリン、大豆タンパク、グルコマンナン、サイリウムハスク末、ドロマイト、クマザサ末、穀物発酵エキス末（マルトデキストリン、穀物発酵抽出物）、マンゴーピューレ、植物発酵エキス末（難消化性デキストリン、植物発酵エキス（黒糖、リンゴ、玄米麹、その他））、L-カルニチンフマル酸塩、酵母（ビオチン含有）、酵母（亜鉛・マンガン・銅・ヨウ素・セレン・クロム・モリブデン含有）、ブドウ糖、温州みかん抽出物、植物性乳酸菌（殺菌）／増粘剤（キサンタンガム）、クエン酸、香料、甘味料（アスパルテーム・L-フェニルアラニン化合物、スクラロース）、紅花色素、ビタミンC、ナイアシン、クチナシ色素、パントテン酸カルシウム、シクロデキストリン、ビタミンB?、ビタミンB?、ビタミンB?、葉酸、ビタミンB?? （一部に小麦・大豆・りんご・バナナ・もも・キウイフルーツを含む）<br />
                  <br />
                  【フライドオニオンとほうれん草のクリームスープ】<br />
                  ●名称：乾燥スープ<br />
                  ●原材料名：大豆たんぱく（アメリカ製造）、水溶性食物繊維（イソマルトデキストリン）、乳たんぱく、クリーミングパウダー、具（オニオン、ほうれん草、米油）、乳たんぱく加水分解物、脱脂粉乳、食塩、ブイヨン（食塩、砂糖、酵母エキス、デキストリン、たまねぎ、香辛料）、ドロマイト、乳等を主要原料とする食品、野菜エキスパウダー、でん粉、ポークエキスパウダー、粉末醤油、デキストリン、グルコマンナン、オニオンパウダー、香辛料／クエン酸K、トレハロース、調味料（アミノ酸等）、増粘剤（グァー、CMC）、ソルビトール、植物レシチン、ビタミンC、ピロリン酸鉄、ナイアシン、ビタミンE、パントテン酸Ca、ビタミンB?、ビタミンB?、ビタミンA、ビタミンB?、ビタミンD、葉酸、ビタミンK?、ビタミンB??、カラメル色素 （一部に乳成分・小麦・大豆・豚肉を含む）<br />
                  <br />
                  【たっぷり生姜の鶏だし粥】<br />
                  ●名称：乾燥がゆ<br />
                  ●原材料名：米加工品（米（国産））、乾燥味付鶏肉、チキンエキス、中華調味料、生姜パウダー、食塩、デキストリン、酵母エキス、乾燥ねぎ、砂糖、香辛料／調味料（アミノ酸等）、香料 （一部に小麦・乳成分・ごま・大豆・鶏肉・豚肉・ゼラチンを含む）
                  </small>
                </>
              },
              {
                label: `
                  内容量
                `,
                value: <>
                  <small>
                    ・酵素グリーンスムージー（バナナ風味）6g × 3袋<br />
                    ・酵素トロピカルスムージー（マンゴー風味）6g × 2袋<br />
                    ・フライドオニオンとほうれん草のクリームスープ 25g × 1袋<br />
                    ・たっぷり生姜の鶏だし粥 13.3g × 1袋
                  </small>
                </>
              },
              {
                label: `
                  注意
                `,
                value: <>
                  <small>
                  【摂取上の注意】<br />
                  ●原材料名をご確認のうえ、食物アレルギーのある方はお召し上がりにならないでください。●濡れた手やスプーンが内容物に触れると、粉末が固まったり、変色する恐れがありますので水分が触れないようにご注意ください。●開封後はチャックをしっかり閉めて、お早めにお召し上がりください。一度に多量摂取すると、お腹が緩くなる場合があります。●乳幼児の手の届かないところにおいてください。
                  </small>
                </>
              },
            ].map(({label, value}) => ({label, value: typeof value === 'string' ? <BefasPre dangerouslySetInnerHTML={{__html: dedent(value)}} /> : <BefasPre>{value}</BefasPre>}))}/>
          </DetailTableContainer>
        </RightContainer>
      </Detail>
      <ProductsContainer>
        <ProductsSection />
      </ProductsContainer>
    </Inner>
  </Outer>
}